"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.2.4'] && _();
}
catch (e) { }
